import { render } from "./ButtonNew.vue?vue&type=template&id=77831402&scoped=true&ts=true"
import script from "./ButtonNew.vue?vue&type=script&lang=ts"
export * from "./ButtonNew.vue?vue&type=script&lang=ts"

import "./ButtonNew.vue?vue&type=style&index=0&id=77831402&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/_vue_us_stage_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77831402"]])

export default __exports__